/* eslint-disable no-undef */
document.addEventListener('DOMContentLoaded', function() {
  // Replace SVG images with inline SVG
  makeSvgInline();
});


// Replace SVG images with inline SVG 
window.makeSvgInline = () => {
  const svgImages = document.querySelectorAll('.js-svg')
  if (svgImages) {
    svgImages.forEach((image) => {
      const imgID = image.getAttribute('id');
      const imgClass = image.getAttribute('class');
      const imgURL = image.getAttribute('src');
      
      fetch(imgURL)
      .then(data => data.text())
      .then(response => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(response, 'text/html');
        let svg = xmlDoc.querySelector('svg');
        
        if (imgID !== null && imgID !== undefined) {
          svg.setAttribute('id', imgID);
        }
        
        if(typeof imgClass !== 'undefined') {
          svg.setAttribute('class', imgClass + ' replaced-svg');
        }
        
        svg.removeAttribute('xmlns:a');
        
        image.parentNode.replaceChild(svg, image);
      })
      
    });
  }
}
